import { FC } from "react";

import { bookingGiftCard } from "../../../types/giftCard";
import { bookingMembership } from "../../../types/membership";

interface GiftCardProps {
  membership: bookingMembership;
}
export const getExpiryDurationInDays = (duration: string) => {
  let days = 0;
  switch (duration) {
    case "one_month":
      days = 30;
      break;
    case "three_months":
      days = 90;
      break;
    case "six_months":
      days = 180;
      break;
    case "one_year":
      days = 365;
      break;
  }
  return days;
};
const Membership: FC<GiftCardProps> = ({ membership }) => {
  return (
    <div className="space-y-2  p-2 border-[1px] border-[#EEF0FF] border-solid rounded border-x-0 border-t-0 my-1">
      <div className="space-y-2  p-2 ">
        <p className="text-color-primary text-lg font-semibold">
          {membership?.name}
        </p>
        <div className="flex gap-1 justify-between"></div>
        <div className="flex flex-wrap justify-between gap-2">
          <div className="text-color-sec-title flex gap-2">
            <p>
              <span className="">{membership?.services?.length}</span>
              <span className="text-xs">خدمات</span>
            </p>
            <p>
              <span className="">{membership?.number_sessions}</span>
              <span className="text-xs">جلسات</span>
            </p>
            <p>
              <span className="">
                {getExpiryDurationInDays(membership?.expire_duration)}
              </span>
              <span className="text-xs">يوم</span>
            </p>
          </div>
          <div className=" text-color-primary">
            <span>{membership?.price}</span>
            <span className="text-xs">ريال</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Membership;
